<template>
   <div>
      <v-container>
         <v-row class="pt-3">
            <v-toolbar dense color="primary white--text" bottom>
               <v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp">
                  Manage Locations
               </v-toolbar-title>
               <v-icon color="white" v-else>mdi-office-building-marker</v-icon>
            </v-toolbar>
         </v-row>
         <v-row class="mt-5" justify-center>
            <v-toolbar>
               <v-btn class="ma-2" small outlined color="indigo" @click="createLocation()">
                  <v-icon left>mdi-plus</v-icon>
                  <div v-if="$vuetify.breakpoint.mdAndUp">Create</div>
               </v-btn>
            </v-toolbar>
         </v-row>
         <v-row class="pt-2">
            <v-col md="12">
               <v-card class="overflow-y-auto">
                  <v-card-title>
                     <v-text-field
                        v-model="table_search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                        clearable
                     ></v-text-field>
                  </v-card-title>
                  <v-data-table
                     dense
                     :headers="table_headers"
                     :items="locationdata"
                     :search="table_search"
                     @click:row="locationRowClick"
                     item-key="location_id"
                     single-select
                  >
                     <!-- eslint-disable-next-line -->
                     <template v-slot:item.actions="{item}">
                        <v-icon small class="mr-2" @click="editLocation(item)">
                           mdi-pencil
                        </v-icon>
                        <v-icon small @click="deleteLocation(item)">
                           mdi-delete
                        </v-icon>
                     </template>
                  </v-data-table>
               </v-card>
            </v-col>
         </v-row>
      </v-container>
      <confirm-dialog ref="confirm" />
   </div>
</template>

<script>
   import ConfirmDlg from "@/components/ConfirmDlg";

   export default {
      inject: ["ShowMessage"],

      components: {
         "confirm-dialog": ConfirmDlg,
      },
      data() {
         return {
            locationdata: [],
            table_headers: [
               {
                  text: "Name",
                  value: "location_name",
                  width: "10%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Description",
                  value: "location_description",
                  width: "20%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Status",
                  value: "status_label",
                  width: "10%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Off Site",
                  value: "offsite_label",
                  width: "10%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "",
                  value: "actions",
                  width: "10%",
                  sortable: false,
                  class: this.$globalstore.table_smallheaderclass,
               },
            ],
            table_search: "",
         };
      },
      methods: {
         locationRowClick(item, row) {
            row.select(!row.isSelected);
         },

         async getLocationList() {
            let response = await this.$http({
               url: "/cca/getlocationlist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (!response.data.error) {
                  this.locationdata = response.data.locationdata;
               } else {
                  this.locationdata = [];
               }
            });
         },

         createLocation() {
            this.$router.push({name: "AddLocation"});
         },

         editLocation(item) {
            this.$router.push({
               name: "EditLocation",
               params: {locationid: item.location_id},
            });
         },

         async deleteLocation(item) {
            let response = await this.$http({
               url: "/cca/removelocation.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  location_id: item.location_id,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$router.push({name: "Login"});
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.getLocationList();
                  }
               }
            });
            console.log(name);
         },
      },
      mounted() {
         if (this.$globalstore && this.$globalstore.appready) {
            this.getLocationList();
         }
      },
   };
</script>

<style>
   tr.v-data-table__selected {
      /* background: #7d92f5 !important; */
      background: #ffcdd2 !important;
   }
</style>
